"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var entity_1 = require("./entity");
var utils_1 = require("./utils");
var Organizer = /** @class */ (function (_super) {
    tslib_1.__extends(Organizer, _super);
    function Organizer() {
        var _this = _super.call(this) || this;
        _this.name = '';
        _this.email = '';
        return _this;
    }
    Organizer_1 = Organizer;
    Organizer.fromJson = function (json) {
        return utils_1.factory(Object.assign(_super.fromJson.call(this, json), new Organizer_1()), json || {});
    };
    var Organizer_1;
    Organizer = Organizer_1 = tslib_1.__decorate([
        utils_1.StaticImplements()
    ], Organizer);
    return Organizer;
}(entity_1.Entity));
exports.Organizer = Organizer;
//# sourceMappingURL=organizer.js.map